import createModel from './lib/create_model';

const FbMessageExternalLink = createModel({
  modelName: 'FbMessageExternalLink',

  properties: {
    title: String,
    url: String,
  },
});

export default FbMessageExternalLink;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/fb_message_external_link.js